import { get, post } from '@/request/request'

export default {
  list(params) {
    return get('/admin/customer/visit/rec/list', params)
  },
  delete(params) {
    return post('/admin/customer/visit/rec/delete', params)
  },
  save(params) {
    return post('/admin/customer/visit/rec/save', params)
  }
}
